import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Checkbox } from '@els/els-react--checkbox';
import { TextInput } from '@els/els-react--text-input';

import './ExportModalContentOptions.scss';

function ExportModalContentOptions({
  data,
  formData,
  setExportOptions,
  setFormDataOptionsHeadline,
  showIncludeOnlyFirstPatentOption = noop,
  hideIncludeOnlyFirstPatentOption = noop,
}) {
  const selectedRange = formData?.range?.selected;
  const selectedFormat = formData?.format?.value;

  useEffect(() => {
    if (selectedRange === 0) {
      showIncludeOnlyFirstPatentOption();
    } else {
      hideIncludeOnlyFirstPatentOption();
    }
  }, [selectedRange, selectedFormat]);

  return (
    <div className="exportModal__options">
      <div className="exportModal__content_row">
        <div className="exportModal__content_row_label">Additional options:</div>
        <div className="exportModal__content_row_value exportModal__options_value">
          {data.options.map((optionItem, index) =>
            optionItem.hidden ? null : (
              // eslint-disable-next-line react/no-array-index-key
              <div className="exportModal__options_value_item" key={`${index}-${optionItem.displayTitle}`}>
                <Checkbox
                  id={`exportModal-content-options-checkbox-${index}-${optionItem.displayTitle}`}
                  checked={optionItem.checked}
                  name={optionItem.name}
                  onChange={() => setExportOptions(index)}
                  label={optionItem.label}
                />
                {optionItem.checked && optionItem.name === 'headline' && (
                  <TextInput
                    id="exportModal-content-options-headline-description"
                    className="e2e-exportModal-content-options-headline-description u-els-margin-top-1o2"
                    size="small"
                    label="Description"
                    shouldHideLabel
                    name="headline"
                    value={formData.options.headline}
                    onChange={(event) => {
                      const { value } = event.currentTarget;
                      setFormDataOptionsHeadline(value);
                    }}
                  />
                )}
              </div>
            )
          )}
        </div>
        <div className="exportModal__content_row_tooltip" />
      </div>
    </div>
  );
}

ExportModalContentOptions.propTypes = {
  data: PropTypes.object,
  formData: PropTypes.object,
  setExportOptions: PropTypes.func.isRequired,
  setFormDataOptionsHeadline: PropTypes.func.isRequired,
};

export default ExportModalContentOptions;
